import { useState, useEffect,useCallback } from "react";
import { useSelector, useDispatch  } from "react-redux";
import {
  addHoliday,
  getHolidays,
  getHoliday,
  editHoliday,
  deleteHoliday,
  getAllHolidays,
} from "../../store/actions/holiday_action";
import _debounce from "lodash/debounce";
// import { useSelectAllIndustry } from "./UseIndustry";

// Get All Data
export const useAllHolidays = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.holiday);
  const [pageNumber, setPageNumber] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
 
  useEffect(() => {
    if (deleteEntry) {
      dispatch(deleteHoliday(deleteEntry));
  }
    allQuery();
  }, [deleteEntry, pageNumber, window.location.search]);
  const allQuery = useCallback(
    _debounce(() => {
     
      dispatch(
        getHolidays({
          pageNumber,
        })
      );
    }, 1000),
    []
  );

  useEffect(() => {
    setPageNumber(1);
  }, [window.location.search]);

  const deleteBtnClicked = async (id) => {
    setDeleteEntry(id);
  };

  return [
    data, setPageNumber, deleteBtnClicked
  ];
};

// Get Single Data
export const useSingleHoliday = (id) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.holiday);
  useEffect(() => {
    dispatch(getHoliday(id));
  }, [id]);
  return [data];
};
// Add Data
export const useCreateHoliday = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.holiday);
  const addData = async (data) => {
    await dispatch(addHoliday(data));
  };
  return [data, addData];
};
export const useUpdateHoliday = () => {
  const dispatch = useDispatch();
  // const data = useSelector((state) => state.holiday);
  const updateData = async (id, data) => {
    await dispatch(editHoliday(id, data));
  };
  return [updateData];
};

export const useSelectAllHoliday = () => {
  const dispatch = useDispatch();
  const [term, setTerm] = useState("");
  const [value, setValue] = useState("");
  const data = useSelector((state) => state.holiday);
  useEffect(() => {
    dispatch(getAllHolidays({ term, value }));
  }, [term, value]);
  return [data, setTerm, setValue];
};


export const useGetDropdownOptions = () => {
  //  const [client, setClientSearchField, setClientSearchValue] =
    // useSelectAllClient();
 
  const [dropdownOptions, setDropdownOptions] = useState({});
  // useEffect(() => {
  //   if (industry && industry.all_industrys) {
  //     const newData = industry.all_industrys.map((item) => {
  //       return { label: item.name, value: item.name };
  //     });
  //     setDropdownOptions({ ...dropdownOptions, industry: newData });
  //   }
  // }, [industry]);
  const loadOptions = async (inputValue, callback, field) => {
    // if (field == "parent_category") {
    //   await setCategorySearchField("name");
    //   await setCategorySearchValue(inputValue);
    //   callback(dropdownOptions.parent_category);
    // }
  };

 
  return [dropdownOptions,loadOptions  ];
};